import React, { useMemo } from 'react';
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { DateTime } from '.';
import { FaClock } from 'react-icons/fa';
import { DataUpdate, RiskAssessment, Terminal } from '../types/graph';

type RiskCardProps = Pick<Partial<RiskAssessment>, 'cei' | 'fei' | 'radius'>
    & Pick<Partial<Terminal>, 'ceiLimit' | 'feiLimit' | 'radiusLimit'> 
    & Pick<Partial<DataUpdate>, 'lastUpdate'>

const RiskCard = ({ cei, fei, radius, ceiLimit, feiLimit, radiusLimit, lastUpdate }: RiskCardProps) => {
    const { t } = useTranslation('common');

    const timeElement = useMemo(() => lastUpdate === undefined ? null : <DateTime date={lastUpdate} />,[lastUpdate])

    return <Card>
        <CardHeader>
            <h4>{t('terminal.home.riskAssessment.title')}</h4>
        </CardHeader>
        <CardBody>
            <dl>
                <dt>{t('terminal.home.riskAssessment.maxFei')}</dt>
                <dd>{fei === undefined ? '' : fei??'-'}</dd>

                <dt>{t('terminal.home.riskAssessment.maxCei')}</dt>
                    <dd>{cei === undefined ? '' : cei ?? '-'}</dd>

                    <dt>{t('terminal.home.riskAssessment.radius')}</dt>
                    <dd>{radius === undefined ? '' : radius ?? '-'}</dd>
            </dl>
        </CardBody>
        <CardFooter>
            <FaClock/> {timeElement}
        </CardFooter>
    </Card>
};


export default RiskCard;